import styled from 'styled-components';

export const DropdownMenuScrollerContainer = styled.div`
  max-height: 50vh;
  overflow-y: scroll;
`;
export const DropdownMenuInputWrapper = styled.span`
  display: flex;
  padding: var(--cl-space-1);
`;
